import apiClient from './client'
import { AreaFuncional, AreaFuncionalCreate } from '../types/api'
import { ensureArray } from '../utils/array'

/**
 * Contexto da tela de Áreas Funcionais.
 * A entidade é do GRUPO; a empresa é o eixo de leitura (empresa -> grupo).
 */
export interface EscopoAreasFuncionais {
  nivel_acesso: number | null
  pode_escrever: boolean
  empresa_id: number | null
  empresa_nome: string | null
  grupo_id: number | null
  grupo_nome: string | null
  qtd_empresas_grupo: number
  empresas_grupo: { id: number; nome: string }[]
}

export const areasFuncionaisApi = {
  escopo: async (empresaId?: number | null): Promise<EscopoAreasFuncionais> => {
    const params: Record<string, unknown> = {}
    if (empresaId) {
      params.empresa_id = empresaId
    }
    const response = await apiClient.get<EscopoAreasFuncionais>('/areas-funcionais/escopo', { params })
    return response.data
  },

  list: async (options?: {
    empresa_id?: number
    grupo_id?: number
    nome?: string
  }): Promise<AreaFuncional[]> => {
    const params: Record<string, unknown> = {}
    if (options?.empresa_id) {
      params.empresa_id = options.empresa_id
    }
    if (options?.grupo_id) {
      params.grupo_id = options.grupo_id
    }
    if (options?.nome) {
      params.nome = options.nome
    }

    const response = await apiClient.get<AreaFuncional[]>('/areas-funcionais', { params })
    return ensureArray<AreaFuncional>(response.data)
  },

  create: async (data: AreaFuncionalCreate): Promise<AreaFuncional> => {
    const response = await apiClient.post<AreaFuncional>('/areas-funcionais', data)
    return response.data
  },

  update: async (id: number, data: Partial<AreaFuncionalCreate>): Promise<AreaFuncional> => {
    const response = await apiClient.put<AreaFuncional>(`/areas-funcionais/${id}`, data)
    return response.data
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/areas-funcionais/${id}`)
  },
}
